"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardUsage = exports.TelestoCreditOrDebit = exports.FastFunds = exports.PersonalCardType = exports.CardPaymentStatus = void 0;
var CardPaymentStatus;
(function (CardPaymentStatus) {
    CardPaymentStatus["AUTHORIZING"] = "AUTHORIZING";
    CardPaymentStatus["AUTHORIZED"] = "AUTHORIZED";
    CardPaymentStatus["CAPTURING"] = "CAPTURING";
    CardPaymentStatus["CAPTURED"] = "CAPTURED";
    CardPaymentStatus["FAILED"] = "FAILED";
    CardPaymentStatus["VOIDING"] = "VOIDING";
    CardPaymentStatus["VOIDED"] = "VOIDED";
    CardPaymentStatus["REFUNDING"] = "REFUNDING";
    CardPaymentStatus["REFUNDED"] = "REFUNDED";
})(CardPaymentStatus = exports.CardPaymentStatus || (exports.CardPaymentStatus = {}));
var PersonalCardType;
(function (PersonalCardType) {
    PersonalCardType["CREDIT"] = "CREDIT";
    PersonalCardType["DEBIT"] = "DEBIT";
    PersonalCardType["PREPAID"] = "PREPAID";
    PersonalCardType["CHARGE"] = "CHARGE";
})(PersonalCardType = exports.PersonalCardType || (exports.PersonalCardType = {}));
var FastFunds;
(function (FastFunds) {
    FastFunds["UNSUPPORTED"] = "UNSUPPORTED";
    FastFunds["DOMESTIC"] = "DOMESTIC";
    FastFunds["CROSS_BORDER"] = "CROSS_BORDER";
    FastFunds["SUPPORTED"] = "SUPPORTED";
})(FastFunds = exports.FastFunds || (exports.FastFunds = {}));
var TelestoCreditOrDebit;
(function (TelestoCreditOrDebit) {
    /** credit the personal card (reimbursement) */
    TelestoCreditOrDebit["CREDIT"] = "CREDIT";
    /** debit the personal card (repayment) */
    TelestoCreditOrDebit["DEBIT"] = "DEBIT";
})(TelestoCreditOrDebit = exports.TelestoCreditOrDebit || (exports.TelestoCreditOrDebit = {}));
var CardUsage;
(function (CardUsage) {
    CardUsage["INDIVIDUAL"] = "INDIVIDUAL";
    CardUsage["CORPORATE"] = "CORPORATE";
})(CardUsage = exports.CardUsage || (exports.CardUsage = {}));
//# sourceMappingURL=telesto.js.map